import CommonUtil from 'packages/common-util/index';
import { COURSE_ATTRIBUTE, ENV_FLAG, KNG_TYPE, KNG_FILE_TYPE, DOCUMENT_FONT_SIZE } from './enum';
import { getTags, getBossDownConfig, getBossConfig, getCheatInfo, getVisitorInfo, getMultipleConf, getCatalogAllPath} from './service';
import dateUtil from 'yxt-biz-pc/src/utils/date';
const FONT_SIZE_VALUE = {
  [DOCUMENT_FONT_SIZE.NORMAL]: 'pc_biz_kng_fontsizenormal', // 字号正常
  [DOCUMENT_FONT_SIZE.SMALL]: 'pc_biz_kng_lbl_fontsizesmall', // 字号偏小
  [DOCUMENT_FONT_SIZE.MINI]: 'pc_biz_kng_lbl_fontsizemini', // 字号极小
  [DOCUMENT_FONT_SIZE.LIMIT]: 'pc_biz_kng_lbl_fontsizelimit' // 极限字号
};
// 学习资料类型,知识卡片,工具表单,扩展阅读 默认无
const studyMaterialTypeOptions = {
  0: '',
  1: 'kng_tag_lbl_display_type1'/** 知识卡片 */,
  2: 'kng_tag_lbl_display_type2'/** 工具表单 */,
  3: 'kng_tag_lbl_display_type3'/** 延伸阅读 */
};

const factorList = [
  'discussion_enable',
  'Face_recognition_configuration_in_class',
  'App_cache_permission_hidden',
  'Tourists_learn',
  'learning_note',
  'sdcs_supplier',
  'kng_tag_display',
  'online_course_skill_label_choose',
  'talentmanagement',
  'AI_subtitles'
];
export default {
  data() {
    return {
      cheatInfoData: {},
      bossDownloadFileTypes: [],
      isBossCanDownload: false,
      isBossCanSetDefinition: false,
      isBossOpenSpeedPlay: false,
      isBuyBbs: false,
      isShowFace: false,
      isHideAppCache: true,
      isShowVisitor: false,
      isShowSupplier: false,
      isShowStudyMaterialType: false
    };
  },
  computed: {
    // 可下载的文件类型【文档，音频，视频】
    downloadFileTypes() {
      if (!this.isBossCanDownload) return [];
      return this.bossDownloadFileTypes;
    },
    // boss设置：是否可以下载文档
    isBossCanDownloadDoc() {
      return this.downloadFileTypes.includes('doc');
    },
    // boss设置：是否可以下载视频
    isBossCanDownloadVideo() {
      return this.downloadFileTypes.includes('video');
    },
    // boss设置：是否可以下载音频
    isBossCanDownloadAudio() {
      return this.downloadFileTypes.includes('audio');
    },
    isUserCanDrag() {
      return this.cheatInfoData.enableForbidDrag !== 1;
    }
  },
  methods: {
    // 获取配置类数据
    async initConfig() {
      return Promise.all([this.initFactor(), this.setDownloadState(), this.setDownloadFileTypes(), this.setDocumentDefinitionState(), this.setSpeedPlayState(), this.setCheatConfig()])
        .then(() => 'complete');
    },
    // 要素预检
    async initFactor() {
      await CommonUtil.preCheckFunctions(factorList);
      const bbsState = CommonUtil.checkTimeOutFnc(factorList[0]);
      this.isBuyBbs = bbsState >= 2 && bbsState <= 4;
      const faceState = CommonUtil.checkTimeOutFnc(factorList[1]);
      this.isShowFace = faceState === 2;
      const appCacheState = CommonUtil.checkTimeOutFnc(factorList[2]);
      this.isHideAppCache = [0, 1, 3, 5].includes(appCacheState);
      const visitorState = CommonUtil.checkTimeOutFnc(factorList[3]);
      this.isShowVisitor = visitorState === 2;

      const noteState = CommonUtil.checkTimeOutFnc(factorList[4]);
      this.isShowNote = noteState === 2;
      const supplierState = CommonUtil.checkTimeOutFnc(factorList[5]);
      this.isShowSupplier = supplierState === 2;
      const tagDisplayState = CommonUtil.checkTimeOutFnc(factorList[6]);
      this.isShowStudyMaterialType = tagDisplayState === 2;

      const onlineSkillTag = CommonUtil.checkTimeOutFnc('online_course_skill_label_choose');
      const talentTag = CommonUtil.checkTimeOutFnc('talentmanagement');
      this.isShowSkillTag = [2, 3, 4].includes(onlineSkillTag) || [2, 3, 4].includes(talentTag);
      const aISubtitles = CommonUtil.checkTimeOutFnc('AI_subtitles');
      this.isHideAISubtitles = aISubtitles >= 2 && aISubtitles <= 4;
    },
    // boss 下载开关状态
    async setDownloadState() {
      const bodyParams = {
        group: 'DOWNLOAD_GROUP',
        key: 'DOWNLOAD_SWITCH',
        orgId: localStorage.orgId || ''
      };
      const res = await getBossConfig(bodyParams);
      if (res.config === 'null' || res.config === null || res.config === 'false' || res.config === '0') {
        this.isBossCanDownload = false;
      } else {
        this.isBossCanDownload = true;
      }
    },
    // boss 可下载的文档类型
    async setDownloadFileTypes() {
      const orgId = localStorage.orgId || '';
      const map = {
        1: 'doc',
        2: 'video',
        3: 'audio'
      };
      const res = await getBossDownConfig(orgId);
      const arr = [];
      res.forEach(item => {
        if (item.openFlag) arr.push(map[item.fileType]);
      });
      this.bossDownloadFileTypes = arr;
    },
    // boss清晰度
    async setDocumentDefinitionState() {
      const bodyParams = {
        group: 'FILE_DEFINITION_GROUP',
        key: 'FILE_DEFINITION_SWITCH_KEY',
        orgId: localStorage.orgId || ''
      };
      const res = await getBossConfig(bodyParams);
      if (res.config === 'null' || res.config === null || res.config === 'false' || res.config === '0') {
        this.isBossCanSetDefinition = false;
      } else {
        this.isBossCanSetDefinition = true;
      }
    },
    // boss 倍速
    async setSpeedPlayState() {
      try {
        const { enabled } = await getMultipleConf();
        this.isBossOpenSpeedPlay = enabled !== '0';
      } catch (error) {
      }
    },
    async setCheatConfig() {
      const res = await getCheatInfo();
      this.cheatInfoData = res;
    },

    isValueChange(key, info) {
      return (info.changeFields || []).includes(key);
    },
    formatDate(timestamp, formatType = 'yyyy-MM-dd HH:MM') {
      if (!timestamp) return '';
      return dateUtil.format(new Date(timestamp), formatType);
    },
    /**
     * 数据转化前initConfig的初始接口都必须完成，转化过程中需要使用配置来显示
     *
     * @param {*} info 课程详情
     * @param {*} configs 自定义字段配置
     * @returns
     * 返回数据对象
     * 权限组{label,content,prefix,auth,textLine,isChange} 须支持isv
     * 人名 {label,userName,suffix,textLine,isChange} 须支持isv
     * 其他文本{label,content,textLine,isChange}
     */
    async getInfoShowData(info, configs = []) {
      const group = [
        { title: this.$t('pc_biz_kng_lbl_maininfo'/** 主要信息 */), list: [] },
        { title: this.$t('pc_biz_kng_lbl_reletedinfo'/** 相关方信息 */), list: [] },
        { title: this.$t('pc_biz_kng_lbl_authsetting'/** 权限设置 */), list: [] },
        { title: this.$t('pc_biz_kng_lbl_funsetting'/** 功能设置 */), list: [] }
      ];
      // 老的审核这边会显示外链课的链接，暂时不加，觉得没必要
      // --- 主要信息 ----
      let list = group[0].list;
      if (info.envFlag === ENV_FLAG.PRIVATE) {
        list.push({ label: this.$t('pc_biz_kng_lbl_privatearea'/** 存储区域 */), content: info.serverGroupName, isChange: this.isValueChange('serverGroupName', info) });
      }
      if (KNG_TYPE.NEWLINK === info.type) {
        list.push({
          label: this.$t('pc_biz_kng_lbl_link'/** 链接 */),
          Link: info.indexPath,
          isChange: this.isValueChange('indexPath', info)
        });
      }
      // 按次课不能预览
      if (info.distributeSourceType && info.orderBuyType === 1) {
        list.push({ label: this.$t('pc_biz_lbl_course_title'/** 课程名称 */), textLine: 1, preview: false, content: info.title, isChange: this.isValueChange('title', info) });
      } else {
        list.push({ label: this.$t('pc_biz_lbl_course_title'/** 课程名称 */), textLine: 1, preview: true, content: info.title, isChange: this.isValueChange('title', info) });
      }
      try {
        const { cataLogAllPath } = await getCatalogAllPath(info.catalogId);
        list.push({ label: this.$t('pc_biz_share_lbl_kcfl'/** 课程分类 */), content: cataLogAllPath || info.catalogName, isChange: this.isValueChange('catalogName', info) });
      } catch (e) {
        console.error(e);
      }
      let configTarget;
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.CONTENT_TAG);
      if (configTarget && configTarget.disabled !== 1) {
        // 接口异步获取
        let tags = [];
        try {
          const { datas } = await getTags(info.draftId || info.id);
          tags = datas.map(item => item.tagName);
        } catch (e) {
          console.error(e);
        }
        list.push({ label: this.$t('pc_biz_kng_lbl_contentlabel'/** 内容标签 */), content: tags, isChange: this.isValueChange('tagIds', info) });
      }
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.SKILL_TAG);
      if (configTarget && configTarget.disabled !== 1 && this.isShowSkillTag) {
        list.push({ label: this.$t('pc_biz_kng_lbl_abilitylabel'/** 能力标签 */), content: (info.skillTagBeans || []).map(item =>item.skillTagName), isChange: this.isValueChange('skillTagBeans', info) });
      }
      // 学习资料类型
      if (this.isShowStudyMaterialType) {
        const studyTypeLabel = info.studyMaterialType === 0 ? '--' : this.$t(studyMaterialTypeOptions[info.studyMaterialType]);
        list.push({ label: this.$t('kng_tag_lbl_display_type_title'/** 类型 */), content: studyTypeLabel });
      }

      if (info.type !== KNG_TYPE.ZIP && info.type !== KNG_TYPE.NEWLINK) {
        const totalTime = info.studyHours || 0;
        const minute = parseInt(totalTime / 60, 10);
        const second = (totalTime - minute * 60);
        list.push({ label: this.$t('pc_biz_kng_lbl_standardduration'/** 标准时长 */), content: this.$t('pc_biz_kng_lbl_studytime1', [minute, second]), isChange: this.isValueChange('studyHours', info) });
        list.push({ label: this.$t('pc_biz_kng_lbl_studyScore'/** 学分 */), content: this.$t('pc_biz_kng_msg_studyscore', [info.studyScore]), isChange: this.isValueChange('studyScore', info) });
      }
      // 平台课程编号
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.UNIQUE_CODE);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: configTarget.attrName, content: info.uniqueCode, isChange: this.isValueChange('uniqueCode', info) });
      }
      // 自定义课程编号
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.CUSTOM_CODE);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: configTarget.attrName, content: info.customCode, isChange: this.isValueChange('customCode', info) });
      }
      // 商城课编号
      if (info.distributeSourceType) {
        list.push({ label: this.$t('pc_kng_lbl_zocode'/** 商城课编号 */), content: info.zoCode, isChange: false });
      }
      const configExpired = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.VALID_DATE);
      if (info.distributeSourceType || (configExpired && configExpired.disabled !== 1)) {
        if (info.expiredTime) {
          const et = this.formatDate(info.expiredTime, 'yyyy-MM-dd');
          if (info.expireNotice === 1) {
            info.expiredTimeTxt = this.$t('kng_common_lbl_expiredtime_desc2'/** 有效期至{0}，到期前{1}天{2}点提醒我 */, [et, info.expireDay, info.expireHours]);
          } else {
            info.expiredTimeTxt = this.$t('kng_common_lbl_expiredtime_desc1'/** 有效期至{0} */, [et]);
          }
        }
        list.push({ label: this.$t('kng_common_expired_time'/* 有效期 */), content: info.expiredTimeTxt || '--', isChange: this.isValueChange('expiredTime', info) });
      }
      // contentCompleteStandard 0默认 1按内容完成，2按进度完成 3点击立即完成
      if ([KNG_TYPE.VIDEO, KNG_TYPE.AUDIO, KNG_TYPE.SCORM, KNG_TYPE.WEIKE].includes(info.type)) {
        let content = '';
        if (info.timeCompleteStandard === 0) {
          content = this.$t('pc_biz_kng_lbl_completestandard6'/* 完成课件内容获得学分 */);
        } else {
          // 完成标准时长的{percent}%和完成课件内容获得学分；完成标准时长的{percent}%获得学分
          const key = info.contentCompleteStandard ? 'pc_biz_kng_lbl_completestandard1' : 'pc_biz_kng_lbl_completestandard2';
          content = this.$t(key, [info.timeCompleteStandard]);
        }
        list.push({ label: this.$t('pc_biz_kng_lbl_class_completion_standard'/** 完课标准 */), content, isChange: this.isValueChange('timeCompleteStandard', info) });
      } else if (info.type === KNG_TYPE.HTML && !!info.specialMode) {
        const content = {
          0: this.$t('pc_biz_kng_lbl_completestandard5'/** 完成标准时长的{percent}%获得学分 */, [info.timeCompleteStandard]),
          2: this.$t('pc_biz_kng_lbl_completestandard4'/** 课程供应商提供学习进度为100%获得学分 */),
          3: this.$t('pc_biz_kng_lbl_completestandard3'/** 进入课件播放页即完成学习且获得学分 */)
        }[info.contentCompleteStandard];
        list.push({ label: this.$t('pc_biz_kng_lbl_class_completion_standard'/** 完课标准 */), content, isChange: this.isValueChange('timeCompleteStandard', info) });
      }
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.PRICE);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: this.$t('pc_biz_common_lbl_price'/** 价格 */), content: this.$t('pc_biz_kng_lbl_pricedescribe'/** {0}积分（学员需使用相应的积分兑换后方可学习 */, [info.price || 0]), isChange: this.isValueChange('price', info) });
      }
      if (info.envFlag === ENV_FLAG.PUBLIC && info.type === KNG_TYPE.DOC && info.fileType !== KNG_FILE_TYPE.IMAGE) {
        let label = this.$t('pc_biz_kng_lbl_imagemode'/** 图片模式 */);
        const content = {
          0: this.isBossCanSetDefinition ? this.$t('kng_lbl_common_dot'/** {0}，{1} */, [label, this.$t(FONT_SIZE_VALUE[info.fontSize])]) : label,
          1: this.$t('pc_biz_kng_lbl_htmlmode'/** HTML模式（以Office文档形式展示，支持复制、搜索） */)
        }[info.displayMode];
        list.push({ label: this.$t('pc_kng_kng_lbl_displaymode'/** 展示模式 */), content, isChange: this.isValueChange('displayMode', info) });
      }
      if (info.type !== KNG_TYPE.NEWLINK) {
        list.push({ label: this.$t('pc_biz_lbl_recommendlevel'/** 推荐系数 */), content: info.recommendLevel || '0', isChange: this.isValueChange('recommendLevel', info) });
      }
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.DESCRIBE);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: this.$t('pc_biz_kng_detail_lbl_introduction'/** 简介 */), content: info.description, textLine: 3, isChange: this.isValueChange('description', info) });
      }
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.ATTACHMENT);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: this.$t('pc_biz_kng_lbl_attachment'/** 附件 */), content: (info.kngAttachSimpleBeans || []).map(item => item.fileName), isChange: this.isValueChange('kngAttachSimpleBeans', info) });
      }
      const baseAttr = configs.filter(item => item.attrKey === COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE && !item.disabled);
      baseAttr.forEach(item => {
        list.push({ label: item.attrName, content: item.selectRange ? item.useName : item.value });
      });
      if (this.isShowSupplier) {
        list.push({ label: this.$t('pc_kng_kngcourse_lbl_supplier'/** 供应商 */), content: info.supplierName ? info.supplierName : '--' });
      }

      // ---- 相关方信息 ----
      list = group[1].list;
      const isShowReward = info.rewardBossSwitch;
      const isAllowReward = info.rewardFlag;
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.CONTRIBUTOR);
      if (configTarget && configTarget.disabled !== 1) {
        const suffix = isShowReward ? (isAllowReward ? this.$t('pc_biz_kng_lbl_allowreward'/** （允许学员打赏） */) : this.$t('pc_biz_kng_lbl_notallowreward'/** （不允许学员打赏） */)) : '';
        list.push({ label: configTarget.attrName, userName: info.contributorsName, suffix, isChange: this.isValueChange('contributorsName', info) });
      }
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.AUTHOR);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: configTarget.attrName, userName: info.author, suffix: info.originality ? this.$t('pc_biz_kng_lbl_original'/** （原创） */) : '', isChange: this.isValueChange('author', info) });
      }
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.LECTURER);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: configTarget.attrName, userName: info.lecturesName, isChange: this.isValueChange('lecturesName', info) });
      }
      configTarget = configs.find(item => item.attrKey === COURSE_ATTRIBUTE.ASSISTANT_LECTURER);
      if (configTarget && configTarget.disabled !== 1) {
        list.push({ label: configTarget.attrName, userName: info.counseLorteacherNames, isChange: this.isValueChange('counseLorteacherNames', info) });
      }
      const relatedAttr = configs.filter(item => item.attrKey === COURSE_ATTRIBUTE.CUSTOM_RELATED && !item.disabled);
      relatedAttr.forEach(item => {
        list.push({ label: item.attrName, content: item.selectRange ? item.useName : item.value });
      });
      // ---- 权限设置 ----
      list = group[2].list;
      list.push({ label: this.$t('pc_biz_kng_lbl_ishide'/** 是否隐藏 */), content: info.visiable === 1 ? this.$t('pc_biz_kng_lbl_isnothide'/** 否 */) : this.$t('pc_biz_kng_lbl_isdohide'/** 是（仅在课程或项目中使用） */), isChange: this.isValueChange('visiable', info) });
      list.push({ label: this.$t('pc_biz_kng_lbl_shareauth'/** 分享权限 */), content: info.shareEnabled === 1 ? this.$t('pc_biz_kng_lbl_allowshare'/** 允许ta人分享 */) : this.$t('pc_biz_kng_lbl_notallowshare'/** 不允许ta人分享 */), isChange: this.isValueChange('shareEnabled', info) });
      if ([KNG_TYPE.SCORM, KNG_TYPE.HTML, KNG_TYPE.NEWLINK].includes(info.type)) {
        list.push({
          label: this.$t('kng_biz_lbl_mobile_view'/** 手机观看 */),
          content: info.appEnabled === 1 ? this.$t('kng_biz_lbl_mobile_view_tip1'/** 支持手机观看（课程需要适配移动端，否则会导致学员使用手机学习时出现异常） */) : this.$t('kng_biz_lbl_mobile_view_tip2'/** 不支持手机观看 */),
          isChange: this.isValueChange('appEnabled', info)
        });
      }
      // 这边逻辑pc和h5有区别，权限组：pc带icon、h5不带icon
      list.push({ label: this.$t('pc_biz_kng_lbl_viewauth'/** 浏览权限 */), content: info.permissionType === 0 ? this.$t('pc_biz_kng_lbl_authwithcatalog'/** 跟随分类浏览权限 */) : '', prefix: info.permissionType === 0 ? '' : this.$t('pc_biz_kng_lbl_authalone'/** 单独设置允许浏览： */), auth: info.browsePermissions, isChange: this.isValueChange('browsePermissions', info) });

      // 这边逻辑pc和h5有区别，权限组：pc带icon、h5不带icon
      if (!info.specialMode && [KNG_TYPE.AUDIO, KNG_TYPE.VIDEO, KNG_TYPE.DOC].includes(info.type) && (this.isBossCanDownloadDoc || this.isBossCanDownloadVideo || this.isBossCanDownloadAudio)) {
        const content = info.allowDown === 0 ? this.$t('pc_biz_kng_lbl_pcnotallowdown'/** 不允许下载 */) : (info.downEnabled === 0 ? this.$t('pc_biz_kng_lbl_downauthwithcatalog'/** 跟随分类中的“允许下载课件”权限 */) : '');
        list.push({ label: this.$t('pc_biz_kng_lbl_pcdownauth'/** 下载权限 */), content, prefix: content ? '' : this.$t('pc_biz_kng_lbl_authdownalone'/** 单独设置允许下载： */), auth: info.downloadPermissions, isChange: this.isValueChange('downloadPermissions', info) });
        if (info.allowDown) {
          list.push({ label: this.$t('kng_lbl_downfile'/** 下载文件 */), content: info.downloadType ? this.$t('kng_lbl_downtype_withwatermark'/** 下载带水印文件 */) : this.$t('pc_kng_lbl_downtype_sourcefile'/** 下载源文件 */), isChange: this.isValueChange('downloadType', info) });
        }
      }
      // 这边逻辑pc和h5有区别，权限组：pc带icon、h5不带icon
      if (!this.isHideAppCache && [KNG_TYPE.AUDIO, KNG_TYPE.VIDEO, KNG_TYPE.DOC].includes(info.type)) {
        const content = info.allowAppDown === 0 ? this.$t('pc_biz_kng_lbl_appnotallowcache'/** 不允许缓存 */) : (info.appDownEnabled === 0 ? this.$t('pc_biz_kng_lbl_cacheauthwithcatalog'/** 跟随分类中的“App缓存课件”权限 */) : '');
        list.push({ label: this.$t('pc_biz_kng_lbl_appcacheauth'/** APP缓存课件权限 */), content, prefix: content ? '' : this.$t('pc_biz_kng_lbl_authcachealone'/** 单独设置允许缓存： */), auth: info.appDownloadPermissions, isChange: this.isValueChange('appDownloadPermissions', info) });
      }
      // 商城课 zip 等不用显示游客设置
      // 游客
      if (this.isShowVisitor && info.type !== KNG_TYPE.ZIP && !info.distributeSourceType) {
        try {
          const { visitorEnabled, authType, encryptEnabled, encryptPwd } = await getVisitorInfo(info.draftId || info.id);
          let content = '';
          if (visitorEnabled === 1) {
            if (authType === 1) {
              if (encryptEnabled === 1) {
                content = this.$t('pc_biz_kng_lbl_visitorwxencrypt', { pwd: encryptPwd });// '支持游客访问，游客需微信授权后观看，加密观看，密码：{pwd}'
              } else {
                content = this.$t('pc_biz_kng_lbl_visitorwx'); // '支持游客访问，游客需微信授权后观看'
              }
            } else {
              if (encryptEnabled === 1) {
                content = this.$t('pc_biz_kng_lbl_visitormbencrypt', { pwd: encryptPwd });// '支持游客访问， 游客需手机号+验证码验证后观看，加密观看，密码：{pwd}'
              } else {
                content = this.$t('pc_biz_kng_lbl_visitormb');// '支持游客访问， 游客需手机号+验证码验证后观看'
              }
            }
          } else {
            content = this.$t('pc_biz_kng_lbl_notsupportvisitor');// '不支持游客访问'
          }
          list.push({ label: this.$t('pc_biz_kng_lbl_visitorstudy'/** 游客访问 */), content, isChange: this.isValueChange('visitorConfDTO', info) });
        } catch (e) {
          console.error(e);
        }
      }
      // ---- 功能设置 ----
      list = group[3].list;
      if (info.weikeType === 2) {
        list.push({
          label: this.$t('pc_biz_kng_lbl_autoupdate'/* 自动更新 */),
          content: info.autoUpgrade ? this.$t('pc_biz_kng_lbl_autoupdate_true'/* 开启自动更新 */) : this.$t('pc_biz_kng_lbl_autoupdate_false'/* 未开启自动更新 */),
          isChange: this.isValueChange('autoUpgrade', info)
        });
      }
      list.push({ label: this.$t('pc_biz_kng_lbl_completecomment'/** 完课评论 */), content: info.enableStudyedAlert ? this.$t('pc_biz_kng_lbl_opencompletecomment'/** 开启完课评论弹窗 */) : this.$t('pc_biz_kng_lbl_closecompletecomment'/** 未开启完课评论弹窗 */), isChange: this.isValueChange('enableStudyedAlert', info) });
      if (this.isBuyBbs) {
        list.push({ label: this.$t('pc_biz_kng_bbscommunity'/** 讨论区 */), content: info.enableBbs ? this.$t('pc_biz_kng_lbl_openbbs'/** 开启讨论区 */) : this.$t('pc_biz_kng_lbl_closebbs'/** 未开启讨论区 */), isChange: this.isValueChange('enableBbs', info) });
      }
      // 笔记区
      if (this.isShowNote) {
        list.push({ label: this.$t('pc_biz_kng_lbl_note'/** 笔记区 */), content: info.enableNote ? this.$t('pc_biz_kng_lbl_openbote'/** 开启公开笔记区 */) : this.$t('pc_biz_kng_lbl_closenote'/** 未开启公开笔记区 */), isChange: this.isValueChange('enableNote', info) });
      }
      // 水印特殊逻辑：非外链课，boss文档开启下载了
      const notSpecial = !info.specialMode && this.isBossCanDownloadDoc;
      if (info.type === KNG_TYPE.DOC && info.envFlag === ENV_FLAG.PUBLIC && notSpecial) {
        list.push({ label: this.$t('pc_biz_kng_lbl_watercontrol'/** 水印控制 */), content: info.watermarkFlag === 0 ? this.$t('pc_biz_kng_lbl_authwithplatform'/** 跟随平台设置 */) : this.$t('pc_biz_kng_lbl_authclose'/** 保持防录屏模式关闭 */) });
      }
      // weikeType 1老微课 2新微课
      if (this.isBossOpenSpeedPlay && [KNG_TYPE.COURSE, KNG_TYPE.VIDEO, KNG_TYPE.AUDIO, KNG_TYPE.WEIKE].includes(info.type) && info.weikeType !== 1) {
        list.push({
          label: this.$t('pc_biz_kng_lbl_speedplay'/** 倍速播放 */),
          content: info.enableMultipleSwitch ? this.$t('pc_kng_lbl_Speed_tip1'/** 已开启倍速播放（学员可以切换1.25/1.5/1.75/2倍速播放） */) : this.$t('pc_kng_lbl_Speed_tip2'/** 未开启倍速播放 */),
          isChange: this.isValueChange('enableMultipleSwitch', info)
        });

        if (info.enableMultipleSwitch) {
          list.push({
            label: this.$t('pc_kng_lbl_hours_calc'/** 学时计算 */),
            content: info.enableMultiple ? this.$t('pc_kng_lbl_Speed_tip3'/** 倍速播放时学习时长也倍速计算（举例：学员2倍速学习5分钟，学习时长算10分钟） */) : this.$t('pc_kng_lbl_Speed_tip4'/** 倍速播放时学习时长不会倍速计算（举例：学员2倍速学习5分钟，学习时长算5分钟） */),
            isChange: this.isValueChange('enableMultiple', info)
          });
        }
      }
      if (this.isUserCanDrag && [KNG_TYPE.VIDEO, KNG_TYPE.AUDIO, KNG_TYPE.COURSE].includes(info.type)) {
        list.push({ label: this.$t('pc_biz_kng_lbl_dragstudy'/** 拖拽学习 */), content: info.enableDrag ? this.$t('pc_biz_kng_lbl_opendragstudy'/** 支持拖拽学习 */) : this.$t('pc_biz_kng_lbl_closedragstudy'/** 不支持拖拽学习（仅限制未完课的学员拖拽） */), isChange: this.isValueChange('enableDrag', info) });
      }
      // 增购 + 机构开启人脸 + 非自采课 + 非老微课 + 排除特定课件类型
      // distributeSourceType 4自采课
      if (this.isShowFace && (info.faceRecognitionConfig || {}).enabled && info.distributeSourceType !== 4 && info.weikeType !== 1 &&
        info.type !== KNG_TYPE.COURSE && info.type !== KNG_TYPE.EXAM && info.type !== KNG_TYPE.NEWLINK && info.type !== KNG_TYPE.ZIP) {
        let content = '';
        const lang = CommonUtil.getLanguage();
        const split = lang === 'zh' ? '，' : ',';
        if (info.faceRecognitionConfig.kngEnabled !== 1) {
          content = this.$t('pc_biz_kng_lbl_closeface'/** 未启人脸识别功能 */);
        } else {
          content = this.$t('pc_biz_kng_lbl_openface'/** 开启人脸识别功能 */);
          if (info.faceRecognitionConfig.studyBeforeRecognition) {
            content += split + this.$t('pc_biz_kng_lbl_facetext3'/** 学习前进行人脸识别 */);
          }
          if (info.faceRecognitionConfig.studyMiddleRecognition) {
            content += split + this.$t('pc_biz_kng_lbl_facetext4'/** 学习中进行人脸识别（需开启防挂机设置，学员触发防挂机时，需要进行人脸识别） */);
          }
          if (info.faceRecognitionConfig.recognitionType === 0) {
            content += split + this.$t('pc_biz_kng_lbl_facetext1'/** 基于图片识别是否是本人 */);
          } else if (info.faceRecognitionConfig.recognitionType === 1) {
            content += split + this.$t('pc_biz_kng_lbl_facetext2'/** 基于图片识别是否本人+活体（拦截通过照片作假的场景） */);
          }
          if (info.faceRecognitionConfig.appPlay) {
            content += split + this.$t('pc_biz_kng_lbl_onlysupportapp'/** 仅支持在APP端观看 */);
          }
        }
        const start = content.startsWith(split);
        if (start) {
          content = content.substring(1);
        }
        list.push({ label: this.$t('pc_biz_kng_lbl_face'/** 人脸识别 */), content });
      }
      // 非音视频、私有云  隐藏AI字幕设置
      // AI字幕
      if (!this.isHideAISubtitles && [KNG_TYPE.VIDEO, KNG_TYPE.AUDIO].includes(info.type) && info.envFlag === ENV_FLAG.PUBLIC) {
        let content;
        if (info.subtitlesFlag === 1) {
          content = info.syncMark === 0 ? this.$t('pc_kng_lbl_ai_subtitles_type2'/** 开启AI字幕，不同步生成关键点 */) : this.$t('pc_kng_lbl_ai_subtitles_type3'/** 开启AI字幕，同步生成关键点 */);
        } else {
          content = this.$t('pc_kng_lbl_ai_subtitles_type1'/** 未开启AI字幕 */);
        }
        list.push({
          label: this.$t('pc_kng_lbl_ai_subtitles'/** AI字幕 */),
          content,
          isChange: this.isValueChange('subtitlesFlag', info) || this.isValueChange('syncMark', info)
        });
      }

      return group;
    }
  }
};
